import { mount } from "svelte";
import "./app.css";
import "./i18n";
import "./theme";
import App from "./App.svelte";
import { isEmbedded } from "../libs/chief-bridge";

// 标记内嵌环境，供 CSS 使用
if (isEmbedded()) {
  document.documentElement.classList.add("embedded");
}

const app = mount(App, {
  target: document.getElementById("app")!,
});

export default app;
